<template>
    <div class="customer-detail">
        <div class="header-return">
            <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
        </div>

        <div>
            <el-tabs tab-position="left" @tab-click="tabClickChange">
                <el-tab-pane label="客户信息">
                    <customerInfo></customerInfo>
                </el-tab-pane>
                <el-tab-pane label="客户地址">
                    <customerAddress></customerAddress>
                </el-tab-pane>
                <el-tab-pane label="订单管理">
                    <customerOrder></customerOrder>
                </el-tab-pane>
                <el-tab-pane label="优惠券">
                    <customerCoupon></customerCoupon>
                </el-tab-pane>
                <el-tab-pane label="用户储值">
                    <customerBalance></customerBalance>
                </el-tab-pane>
                <el-tab-pane label="卡包">
                    <customerCard></customerCard>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import {getCustomerInfo} from '@/api/api'
    import customerInfo from '@/components/userSystem/customerInfo'
    import customerAddress from '@/components/userSystem/customerAddress'
    import customerOrder from '@/components/userSystem/customerOrder'
    import customerCoupon from '@/components/userSystem/customerCoupon'
    import customerBalance from '@/components/userSystem/customerBalance'
    import customerCard from '@/components/userSystem/customerCard'
    export default{
        components:{
            customerInfo,customerAddress,customerOrder,customerCoupon,customerBalance,customerCard
        },
        mounted(){
        },
        methods:{
            returnHistory(){
                window.history.go(-1)
            },
            tabClickChange(val){
                console.log(val)

            }
        }
    }
</script>

<style scoped>
    .customer-detail{
        padding: 10px 20px;
    }
    .header-return{
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/views/userSystem/userSystemContent.vue